module.exports = __webpack_public_path__ + "static/RMTIARE-bbeb0cad266d901de27d242a6ba0ef7b.ttf";